<template>
	<div>
		<!-- {{items}} -->
		<slot
			:loading="loading"
			:items="items"
			:focus="fetch"></slot>
	</div>
</template>

<script>
export default {
	name: 'BAsyncInput',

	props: {
		storeName: { type: String },
		payload: { type: Object },
	},

	data() {
		return {
			loading: false,

			items: [],
		};
	},

	methods: {
		fetch() {
			this.loading = true;
			this.$store
				.dispatch(this.storeName, this.payload)
				.then((res) => {
					console.log(res)
					this.items = res;
				})
				.catch(() => {})
				.finally(() => {
					this.loading = false;
				});
		}

		// addItems(items) {
		// 	this.items = items;
		// },
	},
};
</script>

<style lang="scss" scoped></style>
